var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg185(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 42C28.1646 42 32.2001 40.556 35.4192 37.9141C38.6383 35.2722 40.8418 31.5959 41.6542 27.5115C42.4666 23.4271 41.8377 19.1874 39.8745 15.5147C37.9114 11.8421 34.7356 8.96374 30.8882 7.37012C27.0408 5.77651 22.7598 5.56623 18.7748 6.77512C14.7897 7.984 11.3471 10.5373 9.03351 13.9998C6.71992 17.4624 5.67851 21.6201 6.08671 25.7644C6.49492 29.9088 8.3275 33.7834 11.2722 36.728",
    stroke: "#E8202D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20L24.804 28.636C23.494 30.208 22.838 30.996 21.956 31.036C21.074 31.076 20.35 30.35 18.902 28.902L16 26",
    stroke: "#E8202D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg185);
export default __webpack_public_path__ + "static/media/svg185.f154c706db99000b60b2772c804961e0.svg";
export { ForwardRef as ReactComponent };